import React from 'react';
import { KpiUiBase, SingleColumnSection } from './common';
import { KpiUiSingleColumnOptions } from './types';

export const KpiUiSingleColumn = (props: {
  options: KpiUiSingleColumnOptions;
}) => {
  const { options } = props;
  const { section } = options;
  return (
    <KpiUiBase
      title={options.title}
      subtitle={options.subtitle}
      footer={options.footer}
      fontSize={options.fontSize}
    >
      <SingleColumnSection section={section} />
    </KpiUiBase>
  );
};
